<template>
  <div>
    <template v-if="forms.length">
      <ul
        class="lz-resource-grid mb-3"
        v-for="row in rows"
        :key="row"
        v-show="FormsInRow(row).length">
        <resource-card
          v-for="form in FormsInRow(row)"
          :key="form.uid"
          :title="form.title"
          :is-hidden="form.show === false"
          :admin="isAdmin"
          @edit="$emit('edit', form)"
          @toggle="$emit('toggle', form)">
          <resource-action
            v-if="form.link"
            icon="box-arrow-in-up-right"
            label="Open"
            @click="OpenLink(form.link)" />
          <resource-action
            v-if="form.download"
            icon="download"
            label="Download"
            @click="DownloadFile(form.download)" />
        </resource-card>
      </ul>
    </template>
    <div class="lz-empty-state" v-else>
      <b-icon icon="file-earmark-text" class="lz-empty-icon"></b-icon>
      <p>There aren't any documents or forms to show here yet.</p>
    </div>
  </div>
</template>

<script>
import Services from '../../../services/main.service.vue'
import resourceCard from '../resource-card.vue'
import resourceAction from '../resource-action.vue'

export default {
  name: 'ContentComponent',
  components: {
    resourceCard,
    resourceAction
  },
  props: {
    rows: {
      type: Number,
      required: false,
      default: 1
    },
    forms: {
      type: Array,
      required: false,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    FormsInRow(row) {
      return this.forms.filter((form) => form.row === row)
    },
    OpenLink(link) {
      // noopener: window.open does not imply it the way <a target="_blank"> does,
      // so without it the opened page keeps a handle on window.opener.
      window.open(link, '_blank', 'noopener')
    },
    DownloadFile(fileName) {
      try {
        Services.Home.GetDocsAndForms(fileName)
      } catch (error) {
        console.error(error.message)
      }
    }
  }
}
</script>
